import { Component, OnInit } from '@angular/core';
import { RmAdminService } from '../../../services/rm/rm-admin.service';

@Component({
  selector: 'app-admin-rm-management',
  templateUrl: './admin-rm-management.component.html',
  styleUrls: ['./admin-rm-management.component.scss']
})
export class AdminRmManagementComponent implements OnInit {
  activeTab: 'managers' | 'subscribers' = 'managers';
  loading = true;
  rms: any[] = [];
  subscribers: any[] = [];

  // New RM Form
  showCreateModal = false;
  newRm = {
    name: '',
    employee_id: '',
    email: '',
    phone: '',
    password: '',
    max_client_capacity: 50,
    notes: ''
  };
  creating = false;
  createError = '';

  // Edit RM Modal
  showEditModal = false;
  editingRm: any = null;

  // Reassign Modal
  showReassignModal = false;
  selectedSubscriber: any = null;
  targetRmId = '';
  reassigning = false;

  constructor(private rmAdminService: RmAdminService) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.rmAdminService.listRms().subscribe({
      next: res => {
        if (res.status === 'success') {
          this.rms = res.data || [];
        }
        this.loadSubscribers();
      },
      error: () => {
        this.loadSubscribers();
      }
    });
  }

  loadSubscribers(): void {
    this.rmAdminService.getExpressSubscribers().subscribe({
      next: res => {
        this.loading = false;
        if (res.status === 'success') {
          this.subscribers = res.data || [];
        }
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  openCreateModal(): void {
    this.showCreateModal = true;
    this.createError = '';
    this.newRm = {
      name: '',
      employee_id: '',
      email: '',
      phone: '',
      password: '',
      max_client_capacity: 50,
      notes: ''
    };
  }

  closeCreateModal(): void {
    this.showCreateModal = false;
  }

  submitCreateRm(): void {
    if (!this.newRm.name || !this.newRm.employee_id || !this.newRm.email || !this.newRm.phone || !this.newRm.password) {
      this.createError = 'All fields including initial password are required.';
      return;
    }
    this.creating = true;
    this.createError = '';

    this.rmAdminService.createRm(this.newRm).subscribe({
      next: res => {
        this.creating = false;
        if (res.status === 'success') {
          this.showCreateModal = false;
          this.loadData();
        } else {
          this.createError = res.message || 'Error creating RM';
        }
      },
      error: err => {
        this.creating = false;
        this.createError = err.error?.message || 'Error creating RM account';
      }
    });
  }

  openEditModal(rm: any): void {
    this.editingRm = { ...rm };
    this.showEditModal = true;
  }

  closeEditModal(): void {
    this.showEditModal = false;
    this.editingRm = null;
  }

  submitEditRm(): void {
    if (!this.editingRm) return;
    this.rmAdminService.updateRm(this.editingRm._id, {
      name: this.editingRm.name,
      employee_id: this.editingRm.employee_id,
      email: this.editingRm.email,
      phone: this.editingRm.phone,
      status: this.editingRm.status,
      max_client_capacity: this.editingRm.max_client_capacity,
      notes: this.editingRm.notes
    }).subscribe({
      next: res => {
        if (res.status === 'success') {
          this.showEditModal = false;
          this.loadData();
        }
      }
    });
  }

  toggleRmStatus(rm: any): void {
    const newStatus = rm.status === 'Active' ? 'Inactive' : 'Active';
    if (!confirm(`Are you sure you want to change status of ${rm.name} to ${newStatus}?`)) return;
    this.rmAdminService.updateRm(rm._id, { status: newStatus }).subscribe({
      next: res => {
        if (res.status === 'success') {
          rm.status = newStatus;
        }
      }
    });
  }

  resetRmPassword(rm: any): void {
    const newPwd = prompt(`Enter new password for ${rm.name} (${rm.employee_id}):`);
    if (!newPwd || newPwd.length < 6) {
      if (newPwd !== null) alert('Password must be at least 6 characters');
      return;
    }
    this.rmAdminService.resetPassword(rm._id, newPwd).subscribe({
      next: res => {
        if (res.status === 'success') {
          alert(`Password successfully reset for ${rm.name}!`);
        }
      }
    });
  }

  openReassignModal(sub: any): void {
    this.selectedSubscriber = sub;
    this.targetRmId = sub.assigned_rm ? sub.assigned_rm._id : '';
    this.showReassignModal = true;
  }

  closeReassignModal(): void {
    this.showReassignModal = false;
    this.selectedSubscriber = null;
  }

  submitReassign(): void {
    if (!this.selectedSubscriber || !this.targetRmId) return;
    this.reassigning = true;
    this.rmAdminService.assignRm(this.selectedSubscriber._id, this.targetRmId).subscribe({
      next: res => {
        this.reassigning = false;
        if (res.status === 'success') {
          this.showReassignModal = false;
          this.loadData();
        }
      },
      error: () => {
        this.reassigning = false;
      }
    });
  }
}
